import { Component } from '@angular/core';
import { AuthenticationService } from '../../services/authentication.service';
import { AuthCodeOptions } from '../../models/authCodeOptions';
import { NgIf } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { CodeinputComponent } from './codeinput/codeinput.component';
import { Router } from '@angular/router';
import { ApplicationService } from '../../services/application.service';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [NgIf, FormsModule, CodeinputComponent],
  templateUrl: './login.component.html',
  styleUrl: './login.component.css'
})
export class LoginComponent {
  constructor(private authenticationService:AuthenticationService, private router:Router, private applicationService:ApplicationService) {
    
  }

  email:string = '';
  deliveryMethod:string = '';
  authCodeOptions:AuthCodeOptions|null = null;
  showInvalidEmailMessage:boolean = false;
  showInvalidCodeMessage:boolean = false;
  containerDisplay:string = 'EMAILENTRY';

  async getAuthCodeOptions() {
    if(this.email.length === 0) return;

    this.applicationService.showGlobalSpinner();
    let result = await this.authenticationService.getAuthCodeOptions(this.email);
    this.applicationService.hideGlobalSpinner();
    this.showInvalidEmailMessage = !result.emailIsValid;

    if(result.emailIsValid) {
      this.authCodeOptions = result;
      this.containerDisplay = 'DELIVERYMETHOD'
    }
  }

  async setDeliveryMethod(method:string):Promise<void> {
    if(!this.authCodeOptions || !this.authCodeOptions.authId) return;

    this.deliveryMethod = method;
    this.applicationService.showGlobalSpinner();
    let sendResult = await this.authenticationService.sendAuthCode(this.authCodeOptions.authId, method);
    this.applicationService.hideGlobalSpinner();
    this.containerDisplay = 'CODEENTRY';
  }

  async onCodeComplete(code:string) {
    this.applicationService.showGlobalSpinner();
    let authResult = await this.authenticationService.authenticate(code, this.email);
    this.applicationService.hideGlobalSpinner();
    if(authResult.isSuccess) {
      this.router.navigate(['/events']);
    }
    else {
      this.showInvalidCodeMessage = true;
    }
  }
}
